import { graphql } from '@/generated/gql';

export const DEMAND_CASE_ADD_MUTATION = graphql(/* GraphQL */ `
  mutation DemandCaseAdd($demandId: UUID!, $data: TsrctNegotiationCaseInput!) {
    tesseract {
      demand(id: $demandId) {
        negotiationCase {
          create(data: $data) {
            id
          }
        }
      }
    }
  }
`);
